import React from 'react'
import Select from 'react-select-plus'
import { Button } from '@drifthq/tide-core'
import googleLogo from 'images/google.svg'
import office365Logo from 'images/office365.svg'

import './style.css'

export const CalendarSelectStep = ({
  isGoogleAuthed,
  isMicrosoftAuthed,
  calendarSelected,
  setCalendarSelected,
  calendars,
  onCalendarSelect,
  isFetchCalendarLoading
}) => (
  <div className="calendar-select-container">
    <h1>Book Meetings Faster</h1>
    <p>Give people a direct line to your calendar, and let the Drift Assistant do the heavy lifting.</p>
    {isGoogleAuthed && <img alt="" className="logo calendar-logo" src={googleLogo} /> }
    {isMicrosoftAuthed && <img alt="" className="logo calendar-logo" src={office365Logo} /> }
    <label>Select a calendar:</label>
    <Select
      className="calendar-select"
      value={calendarSelected}
      searchable={false}
      clearable={false}
      isLoading={isFetchCalendarLoading}
      options={calendars
        .map(calendar => {
          return { value: calendar.id, label: calendar.name }
        })}
      onChange={setCalendarSelected}
    />
    <Button
      disabled={!calendarSelected}
      onClick={onCalendarSelect}
    >
      Continue to Drift Chrome Extension
    </Button>
    <div className="calendar-footer">
      With a connected calendar, your Drift Assistant will prepare you for all of your meetings, and keep an eye on your calendar so you don’t get double booked.
    </div>
  </div>
)

export const AECalendarSelectStep = ({
  isGoogleAuthed,
  isMicrosoftAuthed,
  calendarSelected,
  setCalendarSelected,
  calendars,
  onCalendarSelect,
  isFetchCalendarLoading,
}) => (
  <div className="calendar-select-container">
    <h1>Sweet! Which calendar should we add new Drift Meetings to?</h1>
    <label className="calendar-select-AE-seat-label">Connected Drift calendar</label>
    <Select
      className="calendar-select"
      value={calendarSelected}
      searchable={false}
      clearable={false}
      isLoading={isFetchCalendarLoading}
      options={calendars
        .map(calendar => {
          return { value: calendar.id, label: calendar.name }
        })}
      onChange={setCalendarSelected}
      placeholder="Loading..."
    />
    <div className="calendar-select-AE-seat-copy">
      We&rsquo;ll check for any existing events on this calendar so you&rsquo;re never double booked. And don&rsquo;t worry &mdash; you&rsquo;ll have full control over when people can book time with you.
    </div>
    <Button
      size="large"
      disabled={!calendarSelected}
      onClick={onCalendarSelect}
    >
      Connect calendar
    </Button>
  </div>
)



// WEBPACK FOOTER //
// ./src/layouts/CalendarSelectStep/component.js